import type { Adventure } from '../../types'

// Shape Stacker Adventure - Age 3 - Stacking shapes by size
export const tillyShapeCorrect = [
  "Perfect stack! You know how to order shapes!",
  "That's the right way to stack them!",
  "Great job! Big on bottom, small on top!",
  "Excellent! You're a shape stacker!",
  "Wonderful! You understand sizes!",
  "Yes! That's how we build tall towers!",
  "Super stacking! Keep going!",
  "Brilliant! You know your sizes!",
  "Perfect! Stack them high!",
  "You're getting so good at this!"
]

export const tillyShapeWrong = [
  "Hmm, try putting the biggest shape first!",
  "Almost! Which shape is the biggest? Start with that one!",
  "Not quite! Big shapes go on the bottom!",
  "Let's try again! Find the biggest shape first!",
  "So close! Remember: big, medium, small!",
  "Think about it - where do big things go?",
  "Try starting with the biggest circle!",
  "Good try! Big shapes make the best base!",
  "Let's stack big to small!",
  "You're learning! Try biggest first!"
]

export const shapeStackerAdventure: Adventure = {
  id: 'shape-stacker',
  title: 'Shape Stacker',
  theme: 'shapes',
  targetAge: '3',
  difficulty: 'easy',
  estimatedDuration: 8,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hi friend! I'm Tilly! Today we're going to build towers by stacking shapes! Are you ready?",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at these circles! We have a BIG one, a medium one, and a small one. When we stack them big to small, they make a snowman!",
      duration: 5
    },
    choice1: [
      {
        id: 'stack',
        label: "Let's stack shapes!",
        tillyLine: "Yay! Let's build a tower together!",
        nextState: 'quiz-1'
      },
      {
        id: 'snowman',
        label: "Make a snowman!",
        tillyLine: "Snowmen are the best! Let's stack circles!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'tap-correct',
      question: 'Which shape goes FIRST at the bottom?',
      tillyPrompt: 'Pick the BIGGEST circle!',
      options: [
        { id: 'large', label: '🔴 Big', isCorrect: true },
        { id: 'medium', label: '🔵 Medium', isCorrect: false },
        { id: 'small', label: '🟢 Small', isCorrect: false }
      ]
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Fantastic! Big shapes make a strong base! Now let's build even taller towers with more shapes!",
      duration: 4
    },
    choice2: [
      {
        id: 'tall',
        label: "Build a tall tower!",
        tillyLine: "Tall towers are awesome! Let's do it!",
        nextState: 'quiz-2'
      },
      {
        id: 'rocket',
        label: "Make a rocket!",
        tillyLine: "Rockets go to space! Let's build one!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'tap-correct',
      question: 'Now we have four circles! Which goes FIRST?',
      tillyPrompt: 'Pick the BIGGEST one!',
      options: [
        { id: 'xl', label: '🔴 XL', isCorrect: true },
        { id: 'large', label: '🟡 Large', isCorrect: false },
        { id: 'medium', label: '🟢 Medium', isCorrect: false }
      ]
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're a stacking master! Time for the Challenge Round! Stack 5 shapes in the right order!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'tap-correct',
          question: 'Challenge 1: Biggest to smallest. Go!',
          tillyPrompt: 'Pick the first one!',
          options: [
            { id: 'xl', label: '🔴 XL', isCorrect: true },
            { id: 'large', label: '🟡 Large', isCorrect: false },
            { id: 'medium', label: '🟢 Medium', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-2',
          type: 'tap-correct',
          question: 'Challenge 2: Build it high!',
          tillyPrompt: 'Pick the biggest square!',
          options: [
            { id: 'big', label: '⬛ Big', isCorrect: true },
            { id: 'medium', label: '⬜ Medium', isCorrect: false },
            { id: 'small', label: '🔲 Small', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-3',
          type: 'tap-correct',
          question: 'Final challenge: Mix of shapes!',
          tillyPrompt: 'Which is biggest?',
          options: [
            { id: 'circle', label: '🔴 Big Circle', isCorrect: true },
            { id: 'square', label: '🟦 Square', isCorrect: false },
            { id: 'triangle', label: '🔺 Triangle', isCorrect: false }
          ]
        } as any
      ]
    },
    reward: {
      tillyLine: "Outstanding! You built amazing towers! You're officially a Shape Stacking Champion!",
      badgeName: 'Shape Stacker',
      badgeIcon: '🏗️',
      nextPreview: 'Next time, we will learn about more and less!'
    }
  }
}
